const TYPES = Object.freeze({
  SIMPLEVERTICAL: 4,
  SIMPLEHORIZONTAL: 5,
  OPENTEXT: 6,
  NUMERICALTEXT: 7,
  DOCUMENT: 10,
  SIMPLEWITHCHILD: 13,
  MULTIPLEVERTICAL: 14,
  MULTIPLEHORIZONTAL: 15,
});

export default TYPES;
